
import { Component, Vue,Watch } from 'vue-property-decorator';
import { getLotteryPrizeApi,getLotteryListApi,getDeparmentListApi } from '@/api/api';
@Component({
  name:'portalMain',
  components:{
  }
})
export default class PortalMain extends Vue {
  // 是否正在播放音乐
  public isPlay:boolean=false;
  // 部门名单
  public departmentList:any=[];
  // 状态// 1开始，2抽奖中，3继续，4暂停，5结束，6已结束
  public status:any=1;
  // 奖品
  public prize:any='暂无奖品';
  // 部门
  public departmentName:any='';
  // 员工
  public staff:any=''
  ////////////////////////////////////
  // 部门滚动时间
  public depLoadingTime:any=3000;
  // 部门滚动速度
  public depLoadingSpeed:any=100;
  // 每个奖品的间隔时间
  public prizeInterval:any=7000;
  // 名字显示的时间
  public showNameTime:any=2000;
  // 继续的时间
  public keepTime:any=1000;
  /////////////////////////////////////
  // 部门动画对象
  public depObjTime:any=null;
  // 总时间对象
  public allObjTime:any=null;
  // 显示名称时间对象
  public showNameObjTime:any=null;
  ////////////////////////////////////
  // 中奖名单
  public winnersList:any=[]
  // 展示中奖名单
  public showWinnersList:any=[];
  // 当前中奖下标
  public currentIndex:any=0;
  // 当前奖品排序默认0;
  public lastViewOrder:any=0
  // 当前奖品的可中奖数
  public quota:any=0;
  // 当前奖品的id
  public prizeId:any='';
  mounted(){
    this.getDeparmentList();
    this.getLotteryPrize();
  }
  // 控制音乐
  public handlePlay(flag:boolean){
    this.isPlay=flag;
    const el:any=this.$refs.music;
    if(flag){
      el.play();
    }else{
      el.pause();
    }
    
    
  }
  // 获取奖品,isAgain是否再抽一次
  public async getLotteryPrize(isAgain?:boolean){
    const sendData:any={
      isAgain:isAgain?true:false,
      lastViewOrder:this.lastViewOrder
    }
    const {data}:any=await getLotteryPrizeApi(sendData);
    if(data.code==='1003'&&data.data&&data.data.name){
      this.prize=data.data.name;
      this.quota=data.data.quota;
      this.lastViewOrder=data.data.viewOrder;
      this.prizeId=data.data.id;
    }else{
      this.prize='暂无奖品';
      this.quota=0;
      this.status=6;
      this.prizeId='';
    }
  }
  // 获取中奖名单
  public async getLotteryList(){
    const sendData:any={
      fkLotteryPrizesId:this.prizeId,
    }
    const {data}:any=await getLotteryListApi(sendData);
    if(data.code==='1003'&&data.datas&&data.datas.length){
      this.winnersList=data.datas;
      this.status=2;
      this.winnerListAnimation();
    }else{
      this.winnersList=[];
      this.status=6;
    }
  }
  // 获取部门列表
  public async getDeparmentList(){
    const {data}:any=await getDeparmentListApi();
    if(data.code==='1003'&&data.datas&&data.datas.length){
      this.departmentList=data.datas;
    }else{
      this.departmentList=[];
    }
  }
  // 部门滚动动画
  public departmentAnimation(){
    const _that:any=this;
    let i:any=0;
    this.depObjTime=setInterval(()=>{
      if(i===_that.departmentList.length){
        i=0;
      }
      _that.departmentName=_that.departmentList[i]
      i++
    },this.depLoadingSpeed);
    this.stopDepartment();
  }
  // 控制部门停止
  public stopDepartment(){
    const _that:any=this;
    setTimeout(()=>{
      _that.clearDepTime();
      _that.departmentName=_that.winnersList[_that.currentIndex].deparment;
      _that.showName();
    },_that.depLoadingTime)
  }
  // 控制名字显示 flag:true 立刻显示名字，false 要等待
  public showName(flag?:boolean){
    const _that:any=this;
    this.status=4;
    const time:any=flag?0:_that.showNameTime
    _that.showNameObjTime=setTimeout(()=>{
      _that.staff=_that.winnersList[_that.currentIndex].staffName;
      _that.showWinnersList.push(_that.winnersList[_that.currentIndex]);
      this.status=2;
    },time);
  }
  // 中奖名单动画
  public async winnerListAnimation(){
    this.clearDepTime();
    // 获取总长度奖品时间
    const _that:any=this;
    this.departmentAnimation();
    _that.allObjTime=setTimeout(()=>{
      _that.clearDepTime();
      // 如果未抽完 就继续
      // 显示下一个，清空显示并继续
      if(_that.currentIndex<_that.winnersList.length-1){
        _that.status=2;
        _that.staff='';
        _that.departmentName='';
        _that.currentIndex++;
        _that.winnerListAnimation();
      }else{
        _that.status=5
      }
    },_that.prizeInterval)
  }
  // 开始 状态1 变 抽奖中2
  public start(){
    this.clear();
    this.getLotteryList();
  }
  // 继续 状态4 变 抽奖中2
  public keep(){
    this.status=2;
    this.showName(true);
    const _that:any=this;
    setTimeout(()=>{
      _that.staff='';
      _that.departmentName='';
      if(_that.currentIndex<_that.winnersList.length-1){
        _that.currentIndex++;
        _that.winnerListAnimation();
      }else{
        _that.status=5
      }
    },_that.keepTime)
  }
  // 暂停 状态2 变 抽奖中3
  public pause(){
    this.clearDepTime();
    this.clearAllTime();
    this.clearshowNameTime();
    this.status=3;
  }
  // 下一个
  public next(){
    this.clearDepTime();
    this.clearAllTime();
    this.clearshowNameTime();
    this.clear();
    this.status=1;
    this.getLotteryPrize();
  }
  // 重抽
  public again(){
    this.clearDepTime();
    this.clearAllTime();
    this.clearshowNameTime();
    this.clear();
    this.getLotteryPrize(true);
    this.getLotteryList();
  }
  // 清空
  public clear(){
    this.staff='';
    this.currentIndex=0;
    this.departmentName='';
    this.showWinnersList=[];
  }
  // 停止部门动画
  public clearDepTime(){
    clearInterval(this.depObjTime);
    this.depObjTime=null;
  }
  // 停止总试长动画
  public clearAllTime(){
    clearInterval(this.allObjTime);
    this.allObjTime=null;
  }
  // 停止显示名字动画
  public clearshowNameTime(){
    clearInterval(this.showNameObjTime);
    this.showNameObjTime=null;
  }
}
